import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import useSiteContent from "../lib/useSiteContent";

export const Footer = () => {
  const { t, lang } = useLang();
  const contact = useSiteContent("contact", {});
  const address = (lang === "tr" ? contact.address_tr : contact.address_en) || t.footer.address;
  const phone = contact.phone || "+90 (212) 000 00 00";
  const email = contact.email || "contact@alacapartners.com";

  return (
    <footer
      data-testid="public-footer"
      className="bg-[#0F2746] text-[#F3F5F8] relative overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-24 grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16">
        <div>
          <div className="overline text-[#C4A47C] mb-5">{t.nav.services}</div>
          <ul className="space-y-3 text-sm text-[#F3F5F8]/85">
            <li><Link to="/hizmetler" className="ap-link-underline">{t.nav.services}</Link></li>
            <li><Link to="/ekip" className="ap-link-underline">{t.nav.team}</Link></li>
            <li><Link to="/hakkimizda" className="ap-link-underline">{t.nav.about}</Link></li>
            <li><Link to="/iletisim" className="ap-link-underline">{t.nav.contact}</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-[#C4A47C] mb-5">{t.nav.contact}</div>
          <ul className="space-y-3 text-sm text-[#F3F5F8]/85">
            <li>{address}</li>
            <li>{phone}</li>
            <li>{email}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#F3F5F8]/10 px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-3 max-w-[1400px] mx-auto">
        <div className="text-xs text-[#F3F5F8]/50 tracking-wide">
          © {new Date().getFullYear()} Alaca Partners. {t.footer.rights}
        </div>
        <Link
          to="/admin"
          data-testid="footer-admin-link"
          className="text-xs text-[#F3F5F8]/40 hover:text-[#C4A47C] tracking-[0.2em] uppercase"
        >
          {t.footer.admin}
        </Link>
      </div>
    </footer>
  );
};
